import produce from 'immer';

import { FETCH_BROADCASTS_FAILURE, FETCH_BROADCASTS_REQUEST, FETCH_BROADCASTS_SUCCESS } from '@actions/broadcast';

const initialState: IBroadcastStore = {
  broadcasts: null,
  error: null,
};

export default (state: IBroadcastStore = initialState, action: any) =>
  produce(state, (draftState: IBroadcastStore) => {
    switch (action.type) {
      case FETCH_BROADCASTS_REQUEST:
        draftState.broadcasts = { items: [] };
        draftState.error = null;

        return;

      case FETCH_BROADCASTS_SUCCESS:
        draftState.broadcasts = action.response;
        draftState.error = null;

        return;

      case FETCH_BROADCASTS_FAILURE:
        draftState.broadcasts = { items: [] };
        draftState.error = action.error;

        return;
    }
  });
